export default class Toast {
  static info: (message: any, duration?: any, onClose?: any) => void = () => {}
  static success: (message: any, duration?: any, onClose?: any) => void = (joinRoomSuccess: string, number: number) => {}
  static warning: (message: any, duration?: any, onClose?: any) => void = () => {}
  static error: (message: any, duration?: any, onClose?: any) => void = (joinRoomFailed: string, number: number) => {}
  static loading: (message: any, duration?: any, onClose?: any) => void = () => {}
};
